import {useCallback, useMemo, useState} from 'react';

import * as columnDefs from '../../../../../../../components/AGGrid/config/columns-def';
import {datastageApi} from "../../../../../../../api";


export function useLinkedProductsGridUtils({
                                               datastageApi,
                                               section,
                                               defaultFilterRange,
                                               updateLinkedProducts,
                                               handlers
                                           }) {
    const [sortedColId, setSortedColId] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const setSort = useCallback(
        async (colId, direction) => {
            setSortedColId(colId);
            setSortDirection(direction);
            handlers.setLoadingTrue();
            try {

                const linkedProductsData = await datastageApi.products(
                    {sectionIdForProductsToInclude: section?.id},
                    defaultFilterRange,
                    [colId, direction.toUpperCase()]
                );

                const linkedProducts = (linkedProductsData?.content ?? []).map((product) => ({
                    ...product,
                    addedDate: section?.sharedClearanceMemoTOCProductAddedMap?.[product.productId] || '',
                    verified: section?.unConfirmedProductIdList?.[product.productId] ? 'No' : 'Yes',
                    isLinked: true,
                }));

                updateLinkedProducts({
                    totalPages: linkedProductsData?.totalPages,
                    currentPage: linkedProductsData?.pageable?.pageNumber,
                    totalItems: linkedProductsData?.totalElements,
                    linkedProducts,
                    sortParam: [colId, direction.toUpperCase()]
                });


            } catch (error) {
                console.error('Error sorting linkedProducts:', error);
            } finally {
                handlers.setLoadingFalse();
            }
        },
        [defaultFilterRange, updateLinkedProducts, handlers]
    );

    const baseColumns = columnDefs['linkedProducts'](
        ...handlers.columnHandlers
    )['default'];

    const columns = useMemo(() => (
        baseColumns.map(col => ({
            ...col,
            headerComponentParams: {
                ...col.headerComponentParams,
                setSort,
                sortedColId,
                sortDirection,
            }
        }))
    ), [setSort, sortedColId, sortDirection, baseColumns]);

    return {setSort, columns};
}